// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import DTTable from '../../components/AntdTable';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';

const Report = () => {
  const [report, setReport] = useState([]);
  const [link, setLink] = useState([]);
  const token = getToken();
  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL
  const [executionTime, setExecutionTime] = useState(null);

  //console.log('user_id:',user_id)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const startTime = Date.now(); // Start time for the request

        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/${route}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        setLink(response.data.link);
        setReport(response.data.report);
        const endTime = Date.now(); // End time for the request
        setExecutionTime(endTime - startTime); // Calculate the execution time

        setLoading(false);
        document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        setLink([]);
        setReport([]);
        setLoading(false);
      }
    };

    fetchData();
  }, [route]);

  console.log('report link:', link);

  return (
    <>
      {report.lingth == 0 && <p>No Data </p>}

      {report && (
        <DTTable
          data={report}
          link={link}
          token={token}
          executionTime={executionTime}
        />
      )}
    </>
  );
};

export default Report;
